import { Command } from 'commander';
import chalk from 'chalk';
import { installCommand } from './commands/install.js';
import { uninstallCommand } from './commands/uninstall.js';
import { statusCommand } from './commands/status.js';
import { updateCommand } from './commands/update.js';
import { docsCommand } from './commands/docs.js';
import { initCommand } from './commands/init.js';
import { upgradeCommand } from './commands/upgrade.js';
import { createLicenseCommand } from './commands/license.js';
import { doctorCommand } from './commands/doctor.js';
import { devCommand } from './commands/dev.js';
import { tmuxCommand } from './commands/tmux.js';
import { dockerCommand } from './commands/docker.js';
import { validateCurrentLicense } from './lib/license.js';
import { readFileSync } from 'fs';
import { join } from 'path';

const pkg = JSON.parse(readFileSync(join(__dirname, '..', 'package.json'), 'utf-8'));

// Commands that don't require a license
const LICENSE_FREE_COMMANDS = ['license', 'doctor', 'help', '--help', '-h', '--version', '-v'];

async function main() {
  const program = new Command();

  program
    .name('smartstack')
    .description(chalk.cyan('SmartStack Claude Code automation toolkit'))
    .version(pkg.version, '-v, --version');

  // Add license command (always available)
  program.addCommand(createLicenseCommand());

  // Add protected commands (alphabetical order)
  program.addCommand(devCommand);
  program.addCommand(dockerCommand);
  program.addCommand(doctorCommand);
  program.addCommand(docsCommand);
  program.addCommand(initCommand);
  program.addCommand(installCommand);
  program.addCommand(statusCommand);
  program.addCommand(tmuxCommand);
  program.addCommand(uninstallCommand);
  program.addCommand(updateCommand);
  program.addCommand(upgradeCommand);

  // Check if license is required for this command
  const args = process.argv.slice(2);
  const commandName = args[0] || '';
  const requiresLicense = !LICENSE_FREE_COMMANDS.some(cmd =>
    commandName === cmd || commandName.startsWith(cmd)
  );

  // Validate license before running protected commands
  if (requiresLicense && args.length > 0) {
    const result = await validateCurrentLicense();
    if (!result.valid) {
      console.log(chalk.red(`
╔═══════════════════════════════════════════════════════════╗
║                   LICENSE REQUIRED                        ║
╠═══════════════════════════════════════════════════════════╣
║                                                           ║
║   ${chalk.white(result.error || 'No valid license found')}
║                                                           ║
║   To activate a license:                                  ║
║   ${chalk.cyan('smartstack license activate <your-key>')}             ║
║                                                           ║
║   To request a free trial:                                ║
║   ${chalk.cyan('smartstack license trial')}                           ║
║                                                           ║
║   To purchase a license:                                  ║
║   ${chalk.cyan('https://atlashub.io/products/smartstack-cli')}        ║
║                                                           ║
╚═══════════════════════════════════════════════════════════╝
`));
      process.exitCode = 1;
      return;
    }

    // Display warnings (deprecation, grace period, etc.) — don't block
    if (result.warnings?.length) {
      for (const warning of result.warnings) {
        console.log(chalk.yellow(`⚠ ${warning}`));
      }
    }
  }

  program.action(() => {
    console.log(chalk.cyan(`
╔═══════════════════════════════════════════════════════════╗
║                                                           ║
║   ${chalk.bold('SmartStack')} Claude Commands - v${pkg.version}                 ║
║   GitFlow, EF Core, Skills & more                          ║
║                                                           ║
║   Documentation: ${chalk.cyan('ss docs')}                                 ║
║                                                           ║
╚═══════════════════════════════════════════════════════════╝
`));
    program.outputHelp();
  });

  program.parse();
}

main().catch(console.error);
